import { Controller } from "@hotwired/stimulus"

// Beschikbaarheidstabel: klik of sleep over dagen om ze aan of uit te zetten, snelknoppen per rij.
// De vakjes zijn gewone checkboxes in het formulier; toetsenbord en opslaan blijven native.
export default class extends Controller {
  connect() {
    this.dragState = null
    this.stopDrag = () => { this.dragState = null }
    document.addEventListener("mouseup", this.stopDrag)
  }

  disconnect() {
    document.removeEventListener("mouseup", this.stopDrag)
  }

  startDrag(event) {
    const box = this.boxIn(event.currentTarget)
    if (!box || event.button !== 0) return

    this.dragState = !box.checked
    box.checked = this.dragState
    event.preventDefault()
  }

  dragOver(event) {
    if (this.dragState === null) return

    const box = this.boxIn(event.currentTarget)
    if (box) box.checked = this.dragState
  }

  suppressClick(event) {
    if (event.detail > 0) event.preventDefault()
  }

  fillAll(event) {
    this.setRow(event, () => true)
  }

  fillWorkdays(event) {
    this.setRow(event, (box) => box.dataset.workday === "true")
  }

  clear(event) {
    this.setRow(event, () => false)
  }

  setRow(event, state) {
    event.currentTarget.closest("tr").querySelectorAll("input[type='checkbox']").forEach((box) => {
      box.checked = state(box)
    })
  }

  boxIn(cell) {
    return cell.querySelector("input[type='checkbox']")
  }
}
